import Background from "./background"
import TOC from "./toc"
import '../utils/project.css';
import Button from '@mui/material/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function ProjectLayout({ tableOfContents, prefix, background, body, nextProject }) {
    return (
        <>
            <Background background={background} />
            <div className="project-layout">
                <div className="table-of-contents">
                    <TOC toc={tableOfContents} prefix={prefix} />
                </div>
                <div>
                    {body}
                </div>
            </div>
            <div style={{"display": "flex", "flexDirection": "row", "justifyContent": "flex-end", "marginBottom": "2rem"}}>
                <Button variant="text" href={`/${nextProject.url}`} endIcon={<FontAwesomeIcon icon={faChevronRight}/>}>Next Project: {nextProject.name}</Button>
            </div>
        </>
    )
}